import { Box, Divider, Tooltip, Typography } from '@mui/material';
import { UPH } from './updateHistory.classes';

export const getHourLimit = (values: any[] | undefined, hourIdx: number) => {
    const hourString = String(hourIdx).padStart(2, '0');
    const hourData = values?.find((v: any) => v.hour === hourString);
    return { hourString, limit: hourData?.limit || 0 };
};

export const HourLimitCard = ({ hourIdx, values }: { hourIdx: number; values: any[] | undefined }) => {
    const { hourString, limit } = getHourLimit(values, hourIdx);

    return (
        <Tooltip className={UPH.hourTooltip} title={`Limit: ${limit}`} arrow placement="top">
            <Box
                className={UPH.hourCard}
                data-hour={hourString}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#ffffff',
                    borderRadius: '8px',
                    border: '1px solid #e0e0e0',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    overflow: 'hidden',
                    '&:hover': {
                        backgroundColor: '#f0f0f0',
                        transform: 'scale(1.05)',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    },
                }}
            >
                <Box
                    className={UPH.hourCardInnerTop}
                    sx={{
                        width: '100%',
                        p: 1.5,
                        pt: 1,
                        pb: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Typography
                        className={UPH.hourTimeText}
                        sx={{
                            fontSize: '12px',
                            mb: 0.5,
                            fontWeight: 'bold',
                        }}
                    >
                        {`${hourString}:00`}
                    </Typography>
                </Box>
                <Divider
                    className={UPH.hourDivider}
                    sx={{
                        width: '100%',
                        borderColor: '#e0e0e0',
                    }}
                />
                <Box
                    className={UPH.hourCardInnerBottom}
                    sx={{
                        width: '100%',
                        p: 1.5,
                        pt: 1,
                        pb: 1,
                        backgroundColor: '#f5f5f5',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Typography
                        className={UPH.hourLimitText}
                        sx={{
                            fontSize: '16px',
                            color: limit > 0 ? '#000' : '#999',
                        }}
                    >
                        {limit}
                    </Typography>
                </Box>
            </Box>
        </Tooltip>
    );
};
